import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getTopKeywords } from '../wiki_action';
import { SearchOutlined } from '@ant-design/icons';
import { Table, Row, Col, Button, Divider, Select, Input, Space } from 'antd';
import Highlighter from 'react-highlight-words';

class ConfluenceTopKeyword extends Component {
  initial_search_channel = {
    key: 'all_channels',
    value: 'all_channels',
    label: 'All Channels',
  };
  initial_filter_states = {
    search_range: '30days',
    search_channel: this.initial_search_channel,
  };
  constructor(props) {
    super(props);
    this.state = {
      topKeyWords: this.props.topKeyWords,
      channelsWithKeyword: this.props.channelsWithKeyword,
      loading: false,
      searchText: '',
      searchedColumn: '',
      ...this.initial_filter_states,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.topKeyWords !== prevProps.topKeyWords)
      this.setState({ topKeyWords: this.props.topKeyWords });
    if (this.props.channelsWithKeyword !== prevProps.channelsWithKeyword)
      this.setState({ channelsWithKeyword: this.props.channelsWithKeyword });
  }

  onFilter = () => {
    this.setState({ loading: true });
    getTopKeywords({
      wId: this.props.match.params.wId,
      search_channel:
        this.state.search_channel.key === 'all_channels'
          ? false
          : this.state.search_channel,
      search_range: this.state.search_range,
    }).then((res) => {
      if (res.data.success && res.data.topKeyWords) {
        this.setState({
          topKeyWords: res.data.topKeyWords,
          channelsWithKeyword: res.data.channelsWithKeyword,
          loading: false,
        });
      }
    });
  };

  getChannels = () => {
    const { channels } = this.props;
    const { channelsWithKeyword } = this.state;
    let validChannelList = [];
    channelsWithKeyword.forEach((activityChannel) => {
      if (activityChannel.channelId) {
        const channel = channels.find(
          (c) => c.id === activityChannel.channelId
        );
        if (channel)
          validChannelList.push({
            value: channel.id,
            key: channel.id,
            label: channel.name,
          });
        else if (this.props.isWorkspaceAdimin)
          validChannelList.push({
            value: activityChannel.channelId,
            key: activityChannel.channelId,
            label: activityChannel.channelId,
          });
      }
    });
    return validChannelList;
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type='primary'
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size='small'
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (dataIndex == 'created_by') {
        // console.log(record)
        let creator = this.getCreator(record[dataIndex]);
        return creator
          ? creator.toString().toLowerCase().includes(value.toLowerCase())
          : '';
      } else {
        return record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : '';
      }
    },

    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) => {
      if (dataIndex == 'created_by') {
        text = this.getCreator(text);
      }
      return this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      );
    },
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const { channels } = this.props;
    const columns = [
      {
        title: 'Keyword',
        dataIndex: 'keyWord',
        key: 'keyword',
        ...this.getColumnSearchProps('keyWord'),
      },
      {
        title: 'Occurances',
        dataIndex: 'count',
        key: 'count',
      },
      // {
      //   title: "Previous Period",
      //   dataIndex: "count_prev",
      //   key: "count_prev",
      // },
      {
        title: '',
        render: (text, record, index) => (
          <Button
            type='link'
            onClick={() =>
              this.props.history.push(
                `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=analytics&view_page=activity_log&search_text=${record.keyWord}`
              )
            }
          >
            Show Requests
          </Button>
        ),
      },
    ];

    return (
      <>
        <Row
          gutter={[16, 16]}
          justify='space-between'
          align='bottom'
          style={{ padding: 36 }}
        >
          <Col span='24'>
            <>
              <Button
                onClick={() =>
                  this.props.history.push(
                    `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=analytics`
                  )
                }
              >
                Go back
              </Button>
              <Divider />
              <div style={{ margin: 8 }}>
                <Select
                  value={this.state.search_channel.key}
                  loading={channels.length === 0}
                  style={{
                    width: 200,
                    marginRight: 8,
                  }}
                  onChange={(value, data) => {
                    this.setState(
                      {
                        search_channel: value
                          ? data
                          : this.initial_search_channel,
                      },
                      () => this.onFilter()
                    );
                  }}
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={[this.initial_search_channel, ...this.getChannels()]}
                />
                <Select
                  style={{
                    width: 200,
                    marginRight: 8,
                  }}
                  value={this.state.search_range}
                  onChange={(value, data) => {
                    this.setState({ search_range: value }, () =>
                      this.onFilter()
                    );
                  }}
                  options={[
                    {
                      value: 'day',
                      label: 'Past day',
                    },
                    {
                      value: '7days',
                      label: 'Past 7 days',
                    },
                    {
                      value: '30days',
                      label: 'Past 30 days',
                    },
                    {
                      value: '90days',
                      label: 'Past 90 days',
                    },
                    {
                      value: 'year',
                      label: 'Past year',
                    },
                  ]}
                />
                <Button
                  type='link'
                  onClick={() => {
                    this.setState({ ...this.initial_filter_states }, () =>
                      this.onFilter()
                    );
                  }}
                >
                  Reset Filters
                </Button>
              </div>
              <Divider />
              <Table
                loading={this.state.loading}
                dataSource={this.state.topKeyWords}
                columns={columns}
                pagination={{
                  pageSize: 10,
                  // total: this.state.total || 10,
                  // showTotal: (total) => `Total ${total} activities`,
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </>
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    channels: state.skills.channels,
    isWorkspaceAdimin: state.common_reducer.isAdmin,
  };
};

export default withRouter(connect(mapStateToProps, {})(ConfluenceTopKeyword));
